export enum GridThemes {
  ALPINE = 'ag-theme-alpine',
  ALPINE_DARK = 'ag-theme-alpine-dark',
  BALHAM = 'ag-theme-balham',
  BALHAM_DARK = 'ag-theme-balham-dark',
  MATERIAL = 'ag-theme-material'
}
